"use client";

import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Search, RefreshCcw, Globe } from "lucide-react";
import { useState } from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import useClientTranslation from "@/hooks/useClientTranslation";

interface Props {
  onSearch?: (filters: { name: string; billing: string; status: string }) => void;
  onReset?: () => void;
}

export default function TokenFilters({ onSearch, onReset }: Props) {
  const { t } = useClientTranslation("tokenpg");
  const [name, setName] = useState("");
  const [billing, setBilling] = useState("");
  const [status, setStatus] = useState("");

  const handleSearch = () => {
    onSearch?.({ name, billing, status });
  };

  const handleReset = () => {
    setName("");
    setBilling("");
    setStatus("");
    onReset?.();
  };

  // Remove unused Plus import

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between gap-4">
        <CardTitle className="text-2xl">{t("title")}</CardTitle>
        <div className="flex items-center gap-1.5 rounded-md border border-border bg-muted/50 px-3 py-1.5 text-sm text-muted-foreground">
          <Globe size={14} className="shrink-0" />
          <span>API Host:</span>
          <code className="font-mono text-xs text-foreground select-all">{process.env.NEXT_PUBLIC_API_URL || "https://api.ai.soraliststudio.com"}</code>
        </div>
      </CardHeader>
      <CardContent>
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between sm:flex-wrap">
          <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:flex-wrap">
            <div className="grid gap-1.5">
              <Label>{t("tokenName")}</Label>
              <Input
                value={name}
                onChange={e => setName((e.target as HTMLInputElement).value)}
                onKeyDown={handleKeyDown}
                placeholder={t("tokenNamePlaceholder")}
                className="w-full sm:w-48"
              />
            </div>

            <div className="grid gap-1.5">
              <Label>{t("status")}</Label>
              <Select value={status} onValueChange={setStatus}>
                <SelectTrigger className="w-full sm:w-48">
                  <SelectValue placeholder={t("statusPlaceholder")} />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="正常">{t("statusNormal")}</SelectItem>
                  <SelectItem value="禁用">{t("statusDisabled")}</SelectItem>
                </SelectContent>
              </Select>
            </div>
          </div>

          <div className="flex gap-2">
            <Button variant="outline" onClick={handleReset}>
              <RefreshCcw size={14} /> {t("reset")}
            </Button>
            <Button onClick={handleSearch}>
              <Search size={16} /> {t("search")}
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
